module.exports = __webpack_public_path__ + "googlemaps-dps.png";